import React from 'react';
import s from './style.module.css';

class ContactInput extends React.Component {
    render(props) {
        return (
        	<div className={s.inputFieldWrapper}>
                <label className={s.inputLabel} htmlFor={this.props.name}>{this.props.labelText} {this.props.required && <span className={s.asterix}>*</span>}</label>
        		<div className={s.inputErrorWrapper}>
                    <input type={this.props.type} name={this.props.name} value={this.props.value || ''} required={this.props.required} onChange={this.props.onChange} className={ `${this.props.className} ${s.textField}`} />
                    <label className={`${typeof this.props.error !== 'undefined' ? s.mActive : ""} ${s.error} `}></label>
                    <label className={`${typeof this.props.error !== 'undefined' ? s.mActive : ""} ${s.errorText} `}>{typeof this.props.error !== 'undefined' ? this.props.error : ""}</label>
                </div>
        	</div>
        )
    }
}

export default ContactInput;